





















































import { Vue, Component, Prop, Watch, Emit, Ref } from "vue-property-decorator";
import { authenticationStore } from "../api/authentication/authentication.module";
import { FormEvents } from "../constants";
import { GlobalEvent } from "../shared/helpers";

@Component
export default class Sidebar extends Vue {
  mounted() {
    const app: Sidebar = this;
    $(document).ready(function() {
      const main: any = window;
      const $: any = main.$;
    });
  }

  created() {
    this.sidebarInit();
  }

  @Watch("$route")
  handleRouteChange() {
    this.sidebarInit();
  }

  logout() {
    authenticationStore.LOGOUT();
    this.$router.push({ name: "Index" });
  }

  sidebarInit() {
    this.loadDependencyJS(["/assets/plugins/sidemenu/sidemenu.js", "/assets/plugins/sidebar/sidebar.js"]);
  }

  mediaSize() {
    if (window.matchMedia("(max-width: 767px)").matches) {
      $("body").removeClass("toggle-menu");
      $(".menu-hamburger i.menu-hamburger-close").hide();
      $(".menu-hamburger i.menu-hamburger-collapse").show();
    }
  }

  showConfigurationModal() {
    GlobalEvent.$emit(FormEvents.SH_CONFIGURATION_FORM, {});
  }

  showEmailModal() {
    GlobalEvent.$emit(FormEvents.SH_SEND_EMAIL, {});
  }
}
